import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserEmailAddress extends RestApiModel {
  static getResourceEndpoint() {
    return '/user/email-address';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default UserEmailAddress;
